import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload = {}) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SETTINGS || '/admin/settings')
  },

  parse(raw = {}, payload = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch settings',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Ok',
      data: raw.data || {},
    }
  },
}
